import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import { getNumberScales } from 'Helpers/helpers'

const state = {
    outboundMinYear: null,
    outboundMaxYear: null,
    outbound_beginDate: null,
    outbound_lastDate: null,
    outbound_datasets: [],
    outbound_world_map: [],
    outbound_table: null,
    //v2
    outbound_isLoading: false,
    outbound_world_map_lines: [],
    outbound_year: {},
    year_x_location_source: {},
    n_year_x_location_source: {},
}

// getters
const getters = {
    outbound_year: state => {
        return state.outbound_year;
    },
    outbound_isLoading: state => {
        return state.outbound_isLoading;
    },
    outboundMinYear: state => {
        return state.outboundMinYear;
    },
    outboundMaxYear: state => {
        return state.outboundMaxYear;
    },
    outbound_data_date: state => {
        if (state.outbound_beginDate !== null) {
            var _start = state.outbound_beginDate.split("T");
            var _end = state.outbound_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    outbound_datasets: state => {
        return state.outbound_datasets;
    },
    outbound_world_map: state => {
        return state.outbound_world_map;
    },
    outbound_table: state => {
        return state.outbound_table;
    },
    outbound_world_map_lines: state => {
        return state.outbound_world_map_lines;
    }
}

// actions
const actions = {
    getOutboundDatasets(context, payload) {
        state.outbound_isLoading = true;
        var _params = {};
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.year != null) {
                _params.year = main_filters.year;
            }
            if (main_filters.from_country != null) {
                _params.from_country = main_filters.from_country;
            }
            if (main_filters.to_country != null) {
                _params.to_country = main_filters.to_country;
            }
        }

        const request = {
            params: qs.parse(_params)
        };
        //query data
        instance.get('market/outbound/trip', request)
            .then(response => {
                const { rows } = response.data;

                const {
                    year
                } = response.data;

                state.outbound_year = year;
                state.outbound_beginDate = moment(new Date(year.selected + "-01-01")).format("YYYY-MM-DD");
                if (year.selected == moment().format("YYYY")) {
                    state.outbound_lastDate = moment().format("YYYY-MM-DD");
                } else {
                    state.outbound_lastDate = moment(new Date(year.selected + "-12-31")).format("YYYY-MM-DD");
                }

                state.year_x_location_source = response.data;
                state.n_year_x_location_source = response.data;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "outbound_world_map") {
                        context.commit("onOutboundWorldMap", payload);
                    } else if (stateName == "outbound_table") {
                        context.commit("onOutboundTable", payload);
                    }
                })
                state.outbound_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/market/outbound] syntax errors under instant.get");
            })
    }
}

// mutations
const mutations = {
    onOutboundWorldMap(state, payload) {
        // --- start dataset for jvector map
        // items = [{label1:0,label2:0,...,data:0,label:'',location_destination:'',percentage:'',filter_voc_sentiment:null},...]
        let rows = state.n_year_x_location_source.rows || [];
        let outbound_trip = [...new Set(rows.map((resp) => parseInt(resp.outbound_trip)))].sort();
        let max_outbound_trip = Math.max(...outbound_trip);
        let min_outbound_trip = Math.min(...outbound_trip);
        let from_country_code = [...new Set(rows.filter((resp) => resp.from_country_code !=='NOT SPECIFIED').map((resp) => resp.from_country_code.toUpperCase()))].shift();
        let to_country_code = [...new Set(rows.filter((resp) => resp.to_country_code !=='NOT SPECIFIED').map((resp) => resp.to_country_code.toUpperCase()))];
        
        let world_map_data_lines = {
            from_country: from_country_code,
            to_country: to_country_code
        }

        var items = [];
        var total = 0;
        rows.forEach(function(item, index) {
            total += item.outbound_trip;
            var pos = items.map(function(e) {
                return e.to_country;
            }).indexOf(item.to_country);
            if (pos == -1) {
                items.push({
                    "label": item.to_country,
                    "location_source": item.to_country,
                    'country_code': item.to_country_code,
                    "data": item.outbound_trip
                });
            } else {
                items[pos].data += item.outbound_trip;
                items[pos].country_code = item.to_country_code;
            }
        });
        items.forEach(function(item, index) {
            var percentage = ((item.data / total) * 100);
            items[index].percentage = percentage;
            // items[index].label = items[index].label.toUpperCase() + " " + numeral(percentage).format('0,0.00') + "% (" + numeral(item.data).format('0,0') + ")";
        });
        items['line_datas'] = world_map_data_lines;
        items['range_info'] = {
            min: min_outbound_trip,
            max: max_outbound_trip
        }
        items['scales_ranges'] = getNumberScales(0, 9, min_outbound_trip, max_outbound_trip) || []

        //console.log(items['scales_outbound_trip'])
    
        if (total == 0) {
            items = [];
        }
        state.outbound_world_map_lines = world_map_data_lines;
        state.outbound_world_map = items;

        //console.log(items);
        // --- end dataset for jvector map
    },
    onOutboundTable(state, payload) {
        // --- start dataset for v-data-table

        state.outbound_table = state.n_year_x_location_source;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}